import Dashboard from "./Dashboard";
import DetailedEvaluation from "./DetailedEvaluation";
import FinalRecommendation from "./FinalRecommendation";
import Grading from "./Grading";
import ProposalSummary from "./ProposalSummary";

const modules = [
  {
    module: Dashboard,
    path: "/dashboard",
    headerText: "Dashboard",
  },
  {
    module: DetailedEvaluation,
    path: "/detailedEvaluation",
    headerText: "Detailed Evaluation",
  },
  {
    module: FinalRecommendation,
    path: "/finalRecommendation",
    headerText: "Final Recommendation",
  },
  {
    module: Grading,
    path: "/grading",
    headerText: "Grading",
  },
  {
    module: ProposalSummary,
    path: "/proposalSummary",
    headerText: "Proposal Summary",
  },
];

export default modules;
